module.exports = __webpack_public_path__ + "static/media/ordenha_manual2.e1f90061.jpg";